import React, { Component } from 'react'
import { observer } from "mobx-react"
import { Icon } from 'antd';
@observer(["eventStore", "UserStore", "AuthStore", "ViewStore", "web3Store", "AdminStore", "TeamStore"])
class MyBetsPageCard extends Component {

    constructor(props) {
        super(props);
        this.state = { teamOneLogo: "", teamTwoLogo: "", event: { startTime: Date.now() } }
    }

    componentDidMount() {
        const { eventStore, TeamStore } = this.props;
        let self = this;
        setTimeout(() => {
            let thisEvent = eventStore.events.get(this.props.wager.isPropWager ? this.props.wager.originalEventId : this.props.wager.eventId);
            let teamOneId = thisEvent.teams[0];
            let teamTwoId = thisEvent.teams[1];
            let numTeams = thisEvent.teams.length;
            let teamOneObject = TeamStore.teams.get(teamOneId);
            let teamTwoObject = TeamStore.teams.get(teamTwoId);

            self.setState({
                teamOneLogo: teamOneObject.logoUrl,
                teamTwoLogo: teamTwoObject.logoUrl,
                event: thisEvent,
                teamOneObject,
                teamTwoObject
            })

        }, 400)
    }


    render() {


        return (
            <div>
                {this.state.teamOneLogo == "" ? <Icon style={{ fontSize: "20pt", color: "#1890ff", padding:20 }} type="loading" /> :
                    <img style={{ padding: 10 }} alt="Team One Logo" src={this.state.teamOneLogo} />}
                {this.state.teamOneLogo == "" ? <Icon style={{ fontSize: "20pt", color: "#1890ff", padding: 20 }} type="loading" /> :
                    <img style={{ padding: 10 }} alt="Team Two Logo" src={this.state.teamTwoLogo} />}
               
                <div className="space-mono" style={{ color: "rgba(255,255,255,0.6)" }}>{new Date(this.state.event.startTime * 1000).toLocaleDateString()}</div>
            </div>
        )
    }
}
export default MyBetsPageCard;


// WEBPACK FOOTER //
// ./src/components/appComponents/MyBetsPageCard.js